// @vue/component
export const ContentFooter = {
	name: 'ContentFooter',
	template: `
		<div class="crm-messagesender-editor__content__footer">
			<slot/>
		</div>
	`,
};
